import React,{useContext} from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  Link,
  Typography
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Il8nContext } from '../../Helper/i18n';

const ConsentAgreementSection = ({ formik, handleTermsAndConditions, handleAgreementOfConsents, handleAgreementOfConsentsOpen }) => {
    const localeText = useContext(Il8nContext)
    return (
    <>
      <Grid item xs={12}>
        <FormControl>
          <FormControlLabel
            control={
              <Checkbox
                name="isFatca"
                id="isFatca"
                checked={formik.values.isFatca}
                onChange={formik.handleChange}
              />
            }
            label={
              <Typography variant="body2">
                {localeText?.DigiLockerKYCVerificationTaxIndia}
              </Typography>
            }
          />
        </FormControl>
      </Grid>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="agreement-content"
          id="agreement-header"
        >
          <Grid item xs={12}>
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    name="isAgreeToTerms"
                    id="isAgreeToTerms"
                    checked={(formik.values.isAgreeToConcent && formik.values.isAgreeMITC && formik.values.isDDPIConsent && formik.values.isMTFDeclaration)}
                    color={(formik.values.isAgreeToConcent && formik.values.isAgreeMITC && formik.values.isDDPIConsent && formik.values.isMTFDeclaration) ? 'primary' : 'default'}
                    indeterminate={(((formik.values.isAgreeToConcent || formik.values.isAgreeMITC || formik.values.isDDPIConsent || formik.values.isMTFDeclaration) && !(formik.values.isAgreeToConcent && formik.values.isAgreeMITC && formik.values.isDDPIConsent && formik.values.isMTFDeclaration)))}
                    onChange={(e) => handleAgreementOfConsents(e, 'consent')}
                  />
                }
                label={
                  <Typography variant="body2">
                    {localeText?.DigiLockerKYCVerificationIAgree}{' '}
                    <Link
                      target="_blank"
                      onClick={() => handleTermsAndConditions()}
                      sx={{
                        color: '#008FFF',
                        cursor: 'pointer',
                        underline: 'hover'
                      }}
                    >
                      {localeText?.DigiLockerKYCVerificationTerms}
                    </Link>{' '}
                    {localeText?.DigiLockerKYCVerificationTradebulls}
                  </Typography>
                }
              />
            </FormControl>
          </Grid>
        </AccordionSummary>

        <AccordionDetails>
          <Grid container spacing={2} style={{ paddingLeft: '1rem' }}>
              <Grid item xs={12}>
                <FormControl>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="isAgreeToConcent"
                        id="isAgreeToConcent"
                        checked={formik.values.isAgreeToConcent}
                        onChange={(e) => handleAgreementOfConsents(e, 'isAgreeToConcent')}
                      />
                    }
                    label={
                      <Typography variant="body2">
                        {localeText?.DigiLockerKYCVerificationIAgree}{' '}
                        <Link
                          target="_blank"
                          onClick={(e) => {
                            e.preventDefault();
                            handleAgreementOfConsentsOpen(e, 'consent');
                          }}
                          sx={{
                            color: '#008FFF',
                            cursor: 'pointer',
                            underline: 'hover'
                          }}
                        >
                          {localeText?.DigiLockerKYCVerificationConsents}
                        </Link>{' '}
                        {localeText?.DigiLockerKYCVerificationTradebulls}
                      </Typography>
                    }
                  />
                </FormControl>
              </Grid>

            <Grid item xs={12}>
              <FormControl>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="isAgreeMITC"
                      id="isAgreeMITC"
                      checked={formik.values.isAgreeMITC}
                      onChange={(e) =>
                        handleAgreementOfConsents(e, 'mitcConsent')
                      }
                    />
                  }
                  label={
                    <Typography variant="body2">
                      {localeText?.DigiLockerKYCVerificationIagreeMITC}{' '}
                      <Link
                        target="_blank"
                        onClick={(e) =>
                          handleAgreementOfConsentsOpen(e, 'mitcConsent')
                        }
                        sx={{
                          color: '#008FFF',
                          cursor: 'pointer',
                          underline: 'hover'
                        }}
                      >
                        {localeText?.DigiLockerKYCVerificationMITC}
                      </Link>
                    </Typography>
                  }
                />
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="isDDPIConsent"
                      id="isDDPIConsent"
                      checked={formik.values.isDDPIConsent}
                      onChange={(e) =>
                        handleAgreementOfConsents(e, 'ddpiConsent')
                      }
                    />
                  }
                  label={
                    <Typography variant="body2">
                      {localeText?.AddressIagreeisDDPIConsent1}{' '}
                      <Link
                        target="_blank"
                        onClick={(e) =>
                          handleAgreementOfConsentsOpen(e, 'ddpiConsent')
                        }
                        sx={{
                          color: '#008FFF',
                          cursor: 'pointer',
                          underline: 'hover'
                        }}
                      >
                        {localeText?.AddressDDPI}
                      </Link>{' '}
                      {localeText?.AddressIagreeisDDPIConsent2}
                    </Typography>
                  }
                />
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="isMTFDeclaration"
                      id="isMTFDeclaration"
                      checked={formik.values.isMTFDeclaration}
                      onChange={(e) =>
                        handleAgreementOfConsents(e, 'mtfConsent')
                      }
                    />
                  }
                  label={
                    <Typography variant="body2">
                      {localeText?.AddressIagreeisMTFDeclaration1}{' '}
                      {localeText?.AddressIagreeisMTF}
                      <Link
                        target="_blank"
                        onClick={(e) =>
                          handleAgreementOfConsentsOpen(e, 'mtfConsent')
                        }
                        sx={{
                          color: '#008FFF',
                          cursor: 'pointer',
                          underline: 'hover'
                        }}
                      >
                        {localeText?.AddressIagreeisMTFDeclaration2}
                      </Link>{"'"}
                    </Typography>
                  }
                />
              </FormControl>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default ConsentAgreementSection;